import { useState } from "react";

import ContentLayout from "@/layouts/ContentLayout";

import { DashboardFilterType } from "@/types/dashboard";

import { DefaultDashboardFilter } from "@/consts/Dashboard";

import {
  GetDminsByContractCount,
  GetSmfRatioStats,
  GetStatsByContractCount,
} from "@/services/Dashboard";

import DashboardPieChart from "@/components/DashboardPieChart";
import DashboardHorizontalBarChart from "@/components/DashboardHorizontalBarChart";
import DashboardFilter from "@/components/DashboardFilter";
import DashboardProjectSummary from "@/components/DashboardProjectSummary";
import DashboardContractTable from "@/components/DashboardContractTable";
import DashboardTab from "@/components/DashboardTab";
import DashboardSMFRatioChart from "@/components/DashboardSMFRatioChart";
import DashboardDivisionMargin from "@/components/DashboardDivisionMargin";
import DashboardPurchaseTop5 from "@/components/DashboardPurchaseTop5";
import DashboardContractedCompanyPurchase from "@/components/DashboardContractedCompanyPurchase";

export default function DashboardProject() {
  const [searchReady, setSearchReady] = useState<boolean>(false);
  // 사용자가 수정 중인 filter
  const [filter, setFilter] = useState<DashboardFilterType>(
    DefaultDashboardFilter
  );
  // 검색을 눌렀을 때 적용되는 filter
  const [appliedFilter, setAppliedFilter] = useState<DashboardFilterType>(
    DefaultDashboardFilter
  );
  const handleSetDefaultFilter = (newFilter: DashboardFilterType) => {
    const result = { ...filter, ...newFilter };
    setFilter(result);
    setAppliedFilter(result);
    setSearchReady(true);
  };

  const handleChangeFilter = (newFilter: DashboardFilterType) => {
    const result = { ...filter, ...newFilter };
    setFilter(result);
  };

  const handleImmediateApply = (newFilter: DashboardFilterType) => {
    const result = { ...filter, ...newFilter };
    setFilter(result);
    setAppliedFilter(result);
    setSearchReady(true);
  };

  const handleClickSearch = () => {
    setSearchReady(true);
    setAppliedFilter(filter);
  };

  const handleSearchComplete = () => {
    if (searchReady) {
      setSearchReady(false);
    }
  };

  return (
    <ContentLayout>
      <DashboardTab onSearch={handleClickSearch} />
      <div className="flex gap-5">
        <DashboardFilter
          type="project"
          filter={filter}
          onSetDefault={handleSetDefaultFilter}
          onChange={handleChangeFilter}
          onImmediateApply={handleImmediateApply}
        />
        <div className="w-full flex flex-col gap-5">
          <DashboardProjectSummary
            searchReady={searchReady}
            filter={appliedFilter}
            onSearchComplete={handleSearchComplete}
          />
          {/* First row - 3 columns */}
          <div className="grid grid-cols-3 gap-5">
            <DashboardHorizontalBarChart
              type="project"
              title="공급기업 계약 TOP 5"
              searchReady={searchReady}
              method={GetStatsByContractCount}
              filter={appliedFilter}
              label="company_name"
              value="contract_amount"
              onSearchComplete={handleSearchComplete}
            />
            <DashboardHorizontalBarChart
              type="project"
              title="수요기관 계약 TOP 5"
              searchReady={searchReady}
              method={GetDminsByContractCount}
              filter={appliedFilter}
              label="dmin_name"
              value="contract_amount"
              onSearchComplete={handleSearchComplete}
            />
            <DashboardSMFRatioChart
              title="SMF Ratio"
              searchReady={searchReady}
              filter={appliedFilter}
              onSearchComplete={handleSearchComplete}
            />
          </div>
          {/* Recent Projects Table */}
          <DashboardContractTable
            type="project"
            searchReady={searchReady}
            filter={appliedFilter}
            onSearchComplete={handleSearchComplete}
          />
          {/* Second row - 2 columns */}
          <div className="grid grid-cols-2 gap-5">
            <DashboardDivisionMargin
              title="디비전별 마진 금액"
              searchReady={searchReady}
              filter={appliedFilter}
              onSearchComplete={handleSearchComplete}
            />
            <DashboardPurchaseTop5
              title="구매 업체 별 Top 5 매입가 합계 & 비중"
              searchReady={searchReady}
              filter={appliedFilter}
              onSearchComplete={handleSearchComplete}
            />
          </div>
          {/* Third row - full width */}
          <DashboardContractedCompanyPurchase
            title="낙찰된 업체의 구매업체 비율"
            searchReady={searchReady}
            filter={appliedFilter}
            onSearchComplete={handleSearchComplete}
          />
        </div>
      </div>
    </ContentLayout>
  );
}
